import { PropsWithChildren } from 'react';
import { useList } from 'effector-react';
import { $notifications } from '../model/model';

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export const NotificationsProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const alerts = useList($notifications, (item) => (
    <Alert severity={item.variant} key={item.id}>
      {item.message}
    </Alert>
  ));

  return (
    <>
      <Stack
        spacing={1}
        sx={{ width: 300, position: 'absolute', zIndex: 100000000 }}
      >
        {alerts}
      </Stack>
      {children}
    </>
  );
};
